import { uri } from '../../api-endpoint';
import {
  IKoumutenAPIValidationError,
  IKoumutenFromAPISuccessResponse
} from '../../type-conversion/koumuten/from-api-repsonse';
import { KoumutenAPIRequestBody } from '../../type-conversion/koumuten/to-api-request-body';
import { updateTemplateFn } from '../common';

export const updateKoumuten = (token: string) => (koumutenId: number) =>
  updateTemplateFn(
    token,
    uri.koumutenById(koumutenId),
    KoumutenAPIRequestBody,
    IKoumutenFromAPISuccessResponse,
    IKoumutenAPIValidationError
  );
